import Vue from 'vue'
import {allUserRoles, UserRoleEnum} from '@/enums/userRolesEnum'
import { HTTP } from '@/utils/httpCommonUtil';
import { BallPulseLoader } from 'vue-loaders';
import ShiftNotesCard from './cards/notes/ShiftNotesCard';
import ShiftFacilityInfoCard from './cards/facilityInfo/ShiftFacilityInfoCard';
import ShiftProviderInfoCard from './cards/providerInfo/ShiftProviderInfoCard';
import ShiftInfoCard from './cards/shiftInfo/ShiftInfoCard';
import GenericModal from '@/componentsReusable/genericModal.vue';
import ProviderRecommendationsCard from './cards/providerRecommendations/ProviderRecommendationsCard';
import LogisticNeedsCard from './cards/logisticNeeds/logisticNeedsCard';
import AccountingInformationCard from './cards/accountingInformation/AccountingInformationCard';
import ShiftEventHub from '@/components/shift/ShiftEventHub';

export default Vue.extend({
  name: 'Shift',
  data () {
    return {
      cardExpanded: true,
      UserRoleEnum: UserRoleEnum,
      isAuthorized: false,
      shiftInformation: {} as any,
      loadingInitialData: false,
      loadingFacilityName: false,
      showConfirmationModal: false,
      archivingShift: false,
      shiftId: '0',
      invoices: []
    }
  },
  components: {
    BallPulseLoader,
    ShiftNotesCard,
    ShiftFacilityInfoCard,
    ShiftProviderInfoCard,
    ShiftInfoCard,
    ProviderRecommendationsCard,
    AccountingInformationCard,
    GenericModal,
    LogisticNeedsCard
  },
  computed: {
    isAuthorizedToDelete (): boolean {
      return this.$store.getters['user/hasRole']([
        UserRoleEnum.MANAGER
      ]);
    },
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER)
    },
    isFacilityUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.FACILITY_CONTACT)
    }
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole'](allUserRoles);
  },
  async mounted () {
    await this.getShiftGeneralInformation();
  },
  created: function () {
    ShiftEventHub.$on('SHIFT_PROVIDER_CHANGE', this.getShiftGeneralInformation)
  },
  beforeDestroy: function () {
    ShiftEventHub.$off('SHIFT_PROVIDER_CHANGE', this.getShiftGeneralInformation)
  },
  filters: {
    facilityDisplay (shiftInformation: any ) {
      let facilityDisplay = shiftInformation.facilityName;
      if (shiftInformation.specialtyShortName && shiftInformation.specialtyShortName.length) {
        facilityDisplay += ' | ' + shiftInformation.specialtyShortName;
      }
      return facilityDisplay;
    },
  },
  methods: {
    async getShiftGeneralInformation () {
      this.shiftId = this.$route.params.shiftId;
      let showLoadingSpinnerTimeout = setTimeout(() => {
        this.loadingFacilityName = true;
      }, 0);
      try {
        const response = await HTTP.get('/api/shifts/' + this.shiftId + '/general-information');
        clearTimeout(showLoadingSpinnerTimeout);
        this.loadingFacilityName = false;
        if (!response.data || !response.data.data || !response.data.data.shiftInformation) {
          throw new Error("Error retrieving general shift information.");
        }
        this.shiftInformation = response.data.data.shiftInformation;
        this.invoices = response.data.data.invoices || [];
      } catch (err) {
        console.error(err);
        clearTimeout(showLoadingSpinnerTimeout);
        this.loadingFacilityName = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred fetching this shift\'s general information.'
        });
      }
    },
    archiveConfirmed (id: any) {
      this.showConfirmationModal = false;
      this.archiveShift(true);
    },
    archiveShift (bypassArchiveConfirmation: boolean = false) {
      if (!bypassArchiveConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal = true;
        return;
      }

      this.shiftId = this.$route.params.shiftId;
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.archivingShift = true;
      }, 300);
      HTTP.delete('/api/shifts/' + this.shiftId + '/archive-shift')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.archivingShift = false;
        self.shiftInformation.isArchived = true;
        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Success',
          text: 'This shift has been deleted.'
        });
        setTimeout( function () {
          self.$router.replace('/calendar-shifts');
        }, 1750);
      })
      .catch(function (err) {
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.archivingShift = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred archiving this shift.'
        });
      })
    },
    browseToInvoice (invoiceId: number) {
      window.open("/invoices/" + invoiceId, '_blank');
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/shift/Shift.ts